import React, { useEffect, useState } from "react";
import { PublicLayout } from "../../components/PublicLayout";
import { ProductCard } from "../../components/ProductCard";
import { api } from "../../lib/apiClient";
import { categoryIcon } from "../../lib/icons";
import { Search, Sparkles } from "lucide-react";

export default function Catalog() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const params = {};
    if (cat) params.category_id = cat;
    if (search) params.search = search;
    api.get("/products", { params }).then((r) => setProducts(r.data)).catch(() => {});
  }, [cat, search]);

  return (
    <PublicLayout>
      <div className="max-w-6xl mx-auto px-5 sm:px-6 pt-8">
        <p className="font-serif italic text-vino/60 text-lg">explora y elige</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-vino tracking-tight leading-none">Nuestro catálogo</h1>

        <div className="relative max-w-xl mt-5">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-vino" />
          <input data-testid="catalog-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar un dulce…"
            className="w-full bg-blancoCalido rounded-full pl-12 pr-4 py-4 text-cafe placeholder-cafe/40 shadow-[0_10px_30px_rgba(118,27,56,0.07)] border border-beige/60 focus:outline-none focus:ring-2 focus:ring-rosa transition-all" />
        </div>

        <div className="flex gap-3 overflow-x-auto no-scrollbar py-4 -mx-1 px-1 mb-4">
          <button onClick={() => setCat("")} data-testid="cat-todos"
            className={`flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-3 text-sm font-medium transition-all ${cat === "" ? "bg-vino text-crema shadow-md" : "bg-blancoCalido text-cafe/70 border border-beige hover:bg-beige/60"}`}>
            <Sparkles className="w-4 h-4" /> Todo
          </button>
          {categories.map((c) => {
            const Icon = categoryIcon(c.icon);
            const active = cat === c.id;
            return (
              <button key={c.id} onClick={() => setCat(c.id)} data-testid={`cat-${c.id}`}
                className={`flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-3 text-sm font-medium transition-all ${active ? "bg-vino text-crema shadow-md" : "bg-blancoCalido text-cafe/70 border border-beige hover:bg-beige/60"}`}>
                <Icon className={`w-4 h-4 ${active ? "text-crema" : "text-vino"}`} /> {c.name}
              </button>
            );
          })}
        </div>

        {products.length === 0 ? (
          <p className="text-center text-cafe/50 py-16">No encontramos dulces con esos filtros 🌸</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 pb-8">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
